export const proposalTypesMapping = [
    { id: 1, name: "Game Whitelisting" },
    { id: 2, name: "Consensus Member" },
    { id: 3, name: "Emergency Consensus Reset" },
    { id: 4, name: "Setting Update" },
    { id: 5, name: "Initial Liquidity" },
    { id: 6, name: "Withdraw Liquidity" }
  ];
  